<template>
  <div class="chat-inactive-preview" @click="$emit('click')">
    <div class="preview__avatar">
      <div class="chat-inactive__image-wrapper">
        <v-badge v-if="newMessages" color="red" class="chat-badge">
          <template v-slot:badge>
            <span>1</span>
          </template>
          <div
            class="chat-inactive__avatar"
            :style="{ backgroundImage: 'url(' + picture + ')' }"
          >
            <div v-if="details" class="flag__floating">
              <flag class="flag" :iso="details.nationality" />
            </div>
          </div>
        </v-badge>
        <div
          v-else
          class="chat-inactive__avatar"
          :style="{ backgroundImage: 'url(' + picture + ')' }"
        >
          <div v-if="details" class="flag__floating">
            <flag class="flag" :iso="details.nationality" />
          </div>
        </div>
      </div>
    </div>

    <div class="preview__details">
      <div class="connect-data">
        <b>{{ name }}</b>
        <div v-if="details" style="font-size: 12px">
          {{ detail1 }}<br />
          {{ detail2 }}
        </div>
      </div>
    </div>

    <!-- <div class="preview__delete">
      <v-btn v-if="showRemoveButton" @click.stop="deleteDialog = true" class="connect-question-remove" flat icon color="red">
        <v-icon>mdi-undo-variant</v-icon>
      </v-btn>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'chat-inactive-preview',

  data() {
    return {
      loading: false,
    };
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    picture: {
      type: String,
      default: '',
    },
    msg: {
      type: String,
      default: '',
    },
    chatId: {
      type: String,
      default: '',
    },
    lastMessageDetails: {
      type: Object,
      default: () => {},
    },
    inactiveInfo: {
      type: Array,
      default: () => [],
    },
    details: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapState(['bindedUserData', 'user_data']),

    shortMsg() {
      let shortMsg = this.msg;
      if (shortMsg && shortMsg.length > 40) {
        shortMsg = `${shortMsg.slice(0, 40)}...`;
      }
      return shortMsg;
    },

    newMessages() {
      if (
        !this.lastMessageDetails ||
        this.lastMessageDetails.creatorId === this.bindedUserData.id
      ) {
        return false;
      }

      // don't show new message bubble if chat was blocked by sender
      if (
        !this.lastMessageDetails.recieverRead
        // && (!this.inactiveInfo || !this.inactiveInfo.status
        // || (this.inactiveInfo
        //   && this.inactiveInfo.status
        //   && this.inactiveInfo.blockedBy === this.user_data.id))) {
      ) {
        return true;
      }

      return false;
    },

    isScoutOrTeam() {
      return this.userType === 'scouts' || this.userType === 'teams';
    },

    detail1() {
      if (this.isPlayer) {
        return this.details.player_position;
      }

      if (this.isTeam) {
        return this.details.team_league;
      }

      if (this.isTrainer) {
        return this.details.trainer_type;
      }

      if (this.isScout) {
        return this.details.working_for;
      }
      return '';
    },

    detail2() {
      if (this.isPlayer) {
        return this.details.player_team;
      }

      if (this.isTeam) {
        return this.details.team_verband;
      }
      return '';
    },

    isTrainer() {
      return this.details.type === 'trainer';
    },

    isPlayer() {
      return this.details.type === 'player';
    },

    isTeam() {
      return this.details.type === 'teams';
    },

    isScout() {
      return this.details.type === 'scout';
    },
  },

  methods: {},
};
</script>
